export default "__VITE_ASSET__3cb19b40__"